import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0649552d = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _be7424b2 = () => interopDefault(import('../pages/condicoes-utilizacao/index.vue' /* webpackChunkName: "pages/condicoes-utilizacao/index" */))
const _2e13ca02 = () => interopDefault(import('../pages/contacte-nos/index.vue' /* webpackChunkName: "pages/contacte-nos/index" */))
const _e0fea78a = () => interopDefault(import('../pages/home.js' /* webpackChunkName: "pages/home" */))
const _5149603a = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/index" */))
const _1007d602 = () => interopDefault(import('../pages/simulacao-seguro-saude/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/index" */))
const _3021d0a0 = () => interopDefault(import('../pages/simulacao-seguro-viagem/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/index" */))
const _1cf76e62 = () => interopDefault(import('../pages/simulacao-seguro-vida/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/index" */))
const _12ed8833 = () => interopDefault(import('../pages/condicoes-utilizacao/terms.js' /* webpackChunkName: "pages/condicoes-utilizacao/terms" */))
const _72e3ed3f = () => interopDefault(import('../pages/contacte-nos/contact.js' /* webpackChunkName: "pages/contacte-nos/contact" */))
const _28d464f2 = () => interopDefault(import('../pages/contacte-nos/obrigado/index.vue' /* webpackChunkName: "pages/contacte-nos/obrigado/index" */))
const _62a12e28 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/index" */))
const _b8244556 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/index" */))
const _5c9b7ab9 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos" */))
const _6adff848 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulador/index" */))
const _4392ff36 = () => interopDefault(import('../pages/simulacao-seguro-saude/simulacao-seguro-saude.js' /* webpackChunkName: "pages/simulacao-seguro-saude/simulacao-seguro-saude" */))
const _ebdbeb38 = () => interopDefault(import('../pages/simulacao-seguro-saude/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/simulador/index" */))
const _6e14c4ff = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulacao-seguro-viagem.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulacao-seguro-viagem" */))
const _4a5e70c5 = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulador/index" */))
const _b70fa23e = () => interopDefault(import('../pages/simulacao-seguro-vida/simulacao-seguro-vida.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulacao-seguro-vida" */))
const _79f08b98 = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/index" */))
const _458ea220 = () => interopDefault(import('../pages/contacte-nos/obrigado/obrigado.js' /* webpackChunkName: "pages/contacte-nos/obrigado/obrigado" */))
const _00cc4ffb = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/simulation" */))
const _be160164 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/simulation" */))
const _7a81b96e = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulador/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulador/simulation" */))
const _35069b49 = () => interopDefault(import('../pages/simulacao-seguro-saude/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-saude/simulador/simulador" */))
const _2fc48d48 = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulador/simulador" */))
const _a845cd0e = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/simulador" */))
const _6ad2981e = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/index" */))
const _1516ad09 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/_companyId/index" */))
const _139caa56 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/_companyId/index" */))
const _22a13dd1 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/index" */))
const _cc9bc596 = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/index" */))
const _4688e918 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/index" */))
const _963c6136 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/index" */))
const _1a3a5eca = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/_companyId/index" */))
const _0cde25af = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/_companyId/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/_companyId/simulation" */))
const _325ab47c = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/_companyId/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/_companyId/simulation" */))
const _6067f262 = () => interopDefault(import('../pages/simulacao-seguro-casa/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-casa/resultados/_id/results" */))
const _34b2788c = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/results" */))
const _50b1d0d6 = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/results" */))
const _6ed62a77 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/results" */))
const _c90f36b4 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/results" */))
const _0b87b5ba = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/_companyId/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/_companyId/simulador" */))
const _622cad0f = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/index" */))
const _159cb7d5 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/index" */))
const _7b81c62c = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/index" */))
const _6963196c = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/_plan/index" */))
const _5eb1758e = () => interopDefault(import('../pages/simulacao-seguro-saude/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/obrigado/_id/_plan/index" */))
const _065b0f4e = () => interopDefault(import('../pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/index" */))
const _242990a4 = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/_plan/index" */))
const _78c17bf8 = () => interopDefault(import('../pages/simulacao-seguro-viagem/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/obrigado/_id/_plan/index" */))
const _898a0a66 = () => interopDefault(import('../pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/index" */))
const _0f5a8aa6 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/_plan/index" */))
const _e95b412e = () => interopDefault(import('../pages/simulacao-seguro-vida/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/obrigado/_id/_plan/index" */))
const _21f5c57e = () => interopDefault(import('../pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/index" */))
const _67b1d0f9 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/index" */))
const _ab8ef444 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_plan/index" */))
const _d0ed8788 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/results.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/results" */))
const _8d9055da = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/obrigado" */))
const _6422f757 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/contact" */))
const _36f15395 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/_plan/details" */))
const _4856cd12 = () => interopDefault(import('../pages/simulacao-seguro-saude/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-saude/obrigado/_id/_plan/obrigado" */))
const _b8f55d1a = () => interopDefault(import('../pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/contact" */))
const _67ed1bb1 = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/_plan/details" */))
const _3387c714 = () => interopDefault(import('../pages/simulacao-seguro-viagem/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/obrigado/_id/_plan/obrigado" */))
const _eaba5458 = () => interopDefault(import('../pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/contact" */))
const _ab140edc = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/_plan/details" */))
const _cfbc30b2 = () => interopDefault(import('../pages/simulacao-seguro-vida/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-vida/obrigado/_id/_plan/obrigado" */))
const _097d3d7a = () => interopDefault(import('../pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/contact" */))
const _42a89592 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/results.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/results" */))
const _35499381 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_plan/details" */))
const _8515175a = () => interopDefault(import('../pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/index" */))
const _d8a044b0 = () => interopDefault(import('../pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/index" */))
const _30e7290b = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/index" */))
const _cbe607f0 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/index" */))
const _7c5e0872 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/index" */))
const _64592bde = () => interopDefault(import('../pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/obrigado" */))
const _7e6b634e = () => interopDefault(import('../pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/contact" */))
const _bfc38080 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/results.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/results" */))
const _4003e297 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/details" */))
const _b0573926 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/details" */))
const _b33ce9f8 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/index" */))
const _837d99ca = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/details" */))
const _3a343521 = () => interopDefault(import('../pages/detalhes-companhia/_companyName/_companyId/_type/index.vue' /* webpackChunkName: "pages/detalhes-companhia/_companyName/_companyId/_type/index" */))
const _73feb5ff = () => interopDefault(import('../pages/detalhes-companhia/_companyName/_companyId/_type/detalhes-companhia.js' /* webpackChunkName: "pages/detalhes-companhia/_companyName/_companyId/_type/detalhes-companhia" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _0649552d,
    name: "index___en"
  }, {
    path: "/pt",
    component: _0649552d,
    name: "index___pt"
  }, {
    path: "/en/condicoes-utilizacao",
    component: _be7424b2,
    name: "condicoes-utilizacao___en"
  }, {
    path: "/en/contacte-nos",
    component: _2e13ca02,
    name: "contacte-nos___en"
  }, {
    path: "/en/home",
    component: _e0fea78a,
    name: "home___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos",
    component: _5149603a,
    name: "simulacao-seguro-multirriscos___en"
  }, {
    path: "/en/simulacao-seguro-saude",
    component: _1007d602,
    name: "simulacao-seguro-saude___en"
  }, {
    path: "/en/simulacao-seguro-viagem",
    component: _3021d0a0,
    name: "simulacao-seguro-viagem___en"
  }, {
    path: "/en/simulacao-seguro-vida",
    component: _1cf76e62,
    name: "simulacao-seguro-vida___en"
  }, {
    path: "/pt/condicoes-utilizacao",
    component: _be7424b2,
    name: "condicoes-utilizacao___pt"
  }, {
    path: "/pt/contacte-nos",
    component: _2e13ca02,
    name: "contacte-nos___pt"
  }, {
    path: "/pt/home",
    component: _e0fea78a,
    name: "home___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos",
    component: _5149603a,
    name: "simulacao-seguro-multirriscos___pt"
  }, {
    path: "/pt/simulacao-seguro-saude",
    component: _1007d602,
    name: "simulacao-seguro-saude___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem",
    component: _3021d0a0,
    name: "simulacao-seguro-viagem___pt"
  }, {
    path: "/pt/simulacao-seguro-vida",
    component: _1cf76e62,
    name: "simulacao-seguro-vida___pt"
  }, {
    path: "/en/condicoes-utilizacao/terms",
    component: _12ed8833,
    name: "condicoes-utilizacao-terms___en"
  }, {
    path: "/en/contacte-nos/contact",
    component: _72e3ed3f,
    name: "contacte-nos-contact___en"
  }, {
    path: "/en/contacte-nos/obrigado",
    component: _28d464f2,
    name: "contacte-nos-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador",
    component: _62a12e28,
    name: "simulacao-seguro-automovel-simulador___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo",
    component: _b8244556,
    name: "simulacao-seguro-automovel-simulador-novo___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos",
    component: _5c9b7ab9,
    name: "simulacao-seguro-multirriscos-simulacao-seguro-multirriscos___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulador",
    component: _6adff848,
    name: "simulacao-seguro-multirriscos-simulador___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulacao-seguro-saude",
    component: _4392ff36,
    name: "simulacao-seguro-saude-simulacao-seguro-saude___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulador",
    component: _ebdbeb38,
    name: "simulacao-seguro-saude-simulador___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulacao-seguro-viagem",
    component: _6e14c4ff,
    name: "simulacao-seguro-viagem-simulacao-seguro-viagem___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulador",
    component: _4a5e70c5,
    name: "simulacao-seguro-viagem-simulador___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulacao-seguro-vida",
    component: _b70fa23e,
    name: "simulacao-seguro-vida-simulacao-seguro-vida___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador",
    component: _79f08b98,
    name: "simulacao-seguro-vida-simulador___en"
  }, {
    path: "/pt/condicoes-utilizacao/terms",
    component: _12ed8833,
    name: "condicoes-utilizacao-terms___pt"
  }, {
    path: "/pt/contacte-nos/contact",
    component: _72e3ed3f,
    name: "contacte-nos-contact___pt"
  }, {
    path: "/pt/contacte-nos/obrigado",
    component: _28d464f2,
    name: "contacte-nos-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador",
    component: _62a12e28,
    name: "simulacao-seguro-automovel-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo",
    component: _b8244556,
    name: "simulacao-seguro-automovel-simulador-novo___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos",
    component: _5c9b7ab9,
    name: "simulacao-seguro-multirriscos-simulacao-seguro-multirriscos___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulador",
    component: _6adff848,
    name: "simulacao-seguro-multirriscos-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulacao-seguro-saude",
    component: _4392ff36,
    name: "simulacao-seguro-saude-simulacao-seguro-saude___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulador",
    component: _ebdbeb38,
    name: "simulacao-seguro-saude-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulacao-seguro-viagem",
    component: _6e14c4ff,
    name: "simulacao-seguro-viagem-simulacao-seguro-viagem___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulador",
    component: _4a5e70c5,
    name: "simulacao-seguro-viagem-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulacao-seguro-vida",
    component: _b70fa23e,
    name: "simulacao-seguro-vida-simulacao-seguro-vida___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador",
    component: _79f08b98,
    name: "simulacao-seguro-vida-simulador___pt"
  }, {
    path: "/en/contacte-nos/obrigado/obrigado",
    component: _458ea220,
    name: "contacte-nos-obrigado-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/simulation",
    component: _00cc4ffb,
    name: "simulacao-seguro-automovel-simulador-novo-simulation___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/simulation",
    component: _be160164,
    name: "simulacao-seguro-automovel-simulador-simulation___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulador/simulation",
    component: _7a81b96e,
    name: "simulacao-seguro-multirriscos-simulador-simulation___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulador/simulador",
    component: _35069b49,
    name: "simulacao-seguro-saude-simulador-simulador___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulador/simulador",
    component: _2fc48d48,
    name: "simulacao-seguro-viagem-simulador-simulador___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/simulador",
    component: _a845cd0e,
    name: "simulacao-seguro-vida-simulador-simulador___en"
  }, {
    path: "/pt/contacte-nos/obrigado/obrigado",
    component: _458ea220,
    name: "contacte-nos-obrigado-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/simulation",
    component: _00cc4ffb,
    name: "simulacao-seguro-automovel-simulador-novo-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/simulation",
    component: _be160164,
    name: "simulacao-seguro-automovel-simulador-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulador/simulation",
    component: _7a81b96e,
    name: "simulacao-seguro-multirriscos-simulador-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulador/simulador",
    component: _35069b49,
    name: "simulacao-seguro-saude-simulador-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulador/simulador",
    component: _2fc48d48,
    name: "simulacao-seguro-viagem-simulador-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/simulador",
    component: _a845cd0e,
    name: "simulacao-seguro-vida-simulador-simulador___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id",
    component: _6ad2981e,
    name: "simulacao-seguro-automovel-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/:companyId",
    component: _1516ad09,
    name: "simulacao-seguro-automovel-simulador-novo-companyId___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/:companyId",
    component: _139caa56,
    name: "simulacao-seguro-automovel-simulador-companyId___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id",
    component: _22a13dd1,
    name: "simulacao-seguro-multirriscos-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id",
    component: _cc9bc596,
    name: "simulacao-seguro-saude-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id",
    component: _4688e918,
    name: "simulacao-seguro-viagem-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id",
    component: _963c6136,
    name: "simulacao-seguro-vida-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/:companyId",
    component: _1a3a5eca,
    name: "simulacao-seguro-vida-simulador-companyId___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id",
    component: _6ad2981e,
    name: "simulacao-seguro-automovel-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/:companyId",
    component: _1516ad09,
    name: "simulacao-seguro-automovel-simulador-novo-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/:companyId",
    component: _139caa56,
    name: "simulacao-seguro-automovel-simulador-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id",
    component: _22a13dd1,
    name: "simulacao-seguro-multirriscos-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id",
    component: _cc9bc596,
    name: "simulacao-seguro-saude-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id",
    component: _4688e918,
    name: "simulacao-seguro-viagem-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id",
    component: _963c6136,
    name: "simulacao-seguro-vida-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/:companyId",
    component: _1a3a5eca,
    name: "simulacao-seguro-vida-simulador-companyId___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/:companyId?/simulation",
    component: _0cde25af,
    name: "simulacao-seguro-automovel-simulador-novo-companyId-simulation___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/:companyId?/simulation",
    component: _325ab47c,
    name: "simulacao-seguro-automovel-simulador-companyId-simulation___en"
  }, {
    path: "/en/simulacao-seguro-casa/resultados/:id?/results",
    component: _6067f262,
    name: "simulacao-seguro-casa-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/results",
    component: _34b2788c,
    name: "simulacao-seguro-multirriscos-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/results",
    component: _50b1d0d6,
    name: "simulacao-seguro-saude-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/results",
    component: _6ed62a77,
    name: "simulacao-seguro-viagem-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/results",
    component: _c90f36b4,
    name: "simulacao-seguro-vida-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/:companyId?/simulador",
    component: _0b87b5ba,
    name: "simulacao-seguro-vida-simulador-companyId-simulador___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/:companyId?/simulation",
    component: _0cde25af,
    name: "simulacao-seguro-automovel-simulador-novo-companyId-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/:companyId?/simulation",
    component: _325ab47c,
    name: "simulacao-seguro-automovel-simulador-companyId-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-casa/resultados/:id?/results",
    component: _6067f262,
    name: "simulacao-seguro-casa-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/results",
    component: _34b2788c,
    name: "simulacao-seguro-multirriscos-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/results",
    component: _50b1d0d6,
    name: "simulacao-seguro-saude-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/results",
    component: _6ed62a77,
    name: "simulacao-seguro-viagem-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/results",
    component: _c90f36b4,
    name: "simulacao-seguro-vida-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/:companyId?/simulador",
    component: _0b87b5ba,
    name: "simulacao-seguro-vida-simulador-companyId-simulador___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash",
    component: _622cad0f,
    name: "simulacao-seguro-automovel-resultados-id-hash___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/obrigado/:id?/:plan",
    component: _159cb7d5,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan",
    component: _7b81c62c,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/:plan",
    component: _6963196c,
    name: "simulacao-seguro-multirriscos-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/obrigado/:id?/:plan",
    component: _5eb1758e,
    name: "simulacao-seguro-saude-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/pedir-contacto/:id?/:plan",
    component: _065b0f4e,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/:plan",
    component: _242990a4,
    name: "simulacao-seguro-saude-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/obrigado/:id?/:plan",
    component: _78c17bf8,
    name: "simulacao-seguro-viagem-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/pedir-contacto/:id?/:plan",
    component: _898a0a66,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/:plan",
    component: _0f5a8aa6,
    name: "simulacao-seguro-viagem-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/obrigado/:id?/:plan",
    component: _e95b412e,
    name: "simulacao-seguro-vida-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/pedir-contacto/:id?/:plan",
    component: _21f5c57e,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId",
    component: _67b1d0f9,
    name: "simulacao-seguro-vida-resultados-id-companyId___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:plan",
    component: _ab8ef444,
    name: "simulacao-seguro-vida-resultados-id-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash",
    component: _622cad0f,
    name: "simulacao-seguro-automovel-resultados-id-hash___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/obrigado/:id?/:plan",
    component: _159cb7d5,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan",
    component: _7b81c62c,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/:plan",
    component: _6963196c,
    name: "simulacao-seguro-multirriscos-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/obrigado/:id?/:plan",
    component: _5eb1758e,
    name: "simulacao-seguro-saude-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/pedir-contacto/:id?/:plan",
    component: _065b0f4e,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/:plan",
    component: _242990a4,
    name: "simulacao-seguro-saude-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/obrigado/:id?/:plan",
    component: _78c17bf8,
    name: "simulacao-seguro-viagem-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/pedir-contacto/:id?/:plan",
    component: _898a0a66,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/:plan",
    component: _0f5a8aa6,
    name: "simulacao-seguro-viagem-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/obrigado/:id?/:plan",
    component: _e95b412e,
    name: "simulacao-seguro-vida-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/pedir-contacto/:id?/:plan",
    component: _21f5c57e,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId",
    component: _67b1d0f9,
    name: "simulacao-seguro-vida-resultados-id-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:plan",
    component: _ab8ef444,
    name: "simulacao-seguro-vida-resultados-id-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/results",
    component: _d0ed8788,
    name: "simulacao-seguro-automovel-resultados-id-hash-results___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/obrigado/:id?/:plan/obrigado",
    component: _8d9055da,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan/contact",
    component: _6422f757,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/:plan/details",
    component: _36f15395,
    name: "simulacao-seguro-multirriscos-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-saude/obrigado/:id?/:plan/obrigado",
    component: _4856cd12,
    name: "simulacao-seguro-saude-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-saude/pedir-contacto/:id?/:plan/contact",
    component: _b8f55d1a,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/:plan/details",
    component: _67ed1bb1,
    name: "simulacao-seguro-saude-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-viagem/obrigado/:id?/:plan/obrigado",
    component: _3387c714,
    name: "simulacao-seguro-viagem-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-viagem/pedir-contacto/:id?/:plan/contact",
    component: _eaba5458,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/:plan/details",
    component: _ab140edc,
    name: "simulacao-seguro-viagem-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-vida/obrigado/:id?/:plan/obrigado",
    component: _cfbc30b2,
    name: "simulacao-seguro-vida-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-vida/pedir-contacto/:id?/:plan/contact",
    component: _097d3d7a,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/results",
    component: _42a89592,
    name: "simulacao-seguro-vida-resultados-id-companyId-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:plan/details",
    component: _35499381,
    name: "simulacao-seguro-vida-resultados-id-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/results",
    component: _d0ed8788,
    name: "simulacao-seguro-automovel-resultados-id-hash-results___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/obrigado/:id?/:plan/obrigado",
    component: _8d9055da,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan/contact",
    component: _6422f757,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/:plan/details",
    component: _36f15395,
    name: "simulacao-seguro-multirriscos-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/obrigado/:id?/:plan/obrigado",
    component: _4856cd12,
    name: "simulacao-seguro-saude-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/pedir-contacto/:id?/:plan/contact",
    component: _b8f55d1a,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/:plan/details",
    component: _67ed1bb1,
    name: "simulacao-seguro-saude-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/obrigado/:id?/:plan/obrigado",
    component: _3387c714,
    name: "simulacao-seguro-viagem-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/pedir-contacto/:id?/:plan/contact",
    component: _eaba5458,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/:plan/details",
    component: _ab140edc,
    name: "simulacao-seguro-viagem-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/obrigado/:id?/:plan/obrigado",
    component: _cfbc30b2,
    name: "simulacao-seguro-vida-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/pedir-contacto/:id?/:plan/contact",
    component: _097d3d7a,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/results",
    component: _42a89592,
    name: "simulacao-seguro-vida-resultados-id-companyId-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:plan/details",
    component: _35499381,
    name: "simulacao-seguro-vida-resultados-id-plan-details___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan",
    component: _8515175a,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan",
    component: _d8a044b0,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash",
    component: _30e7290b,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan",
    component: _cbe607f0,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/:plan",
    component: _7c5e0872,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan",
    component: _8515175a,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan",
    component: _d8a044b0,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash",
    component: _30e7290b,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan",
    component: _cbe607f0,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/:plan",
    component: _7c5e0872,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan?/obrigado",
    component: _64592bde,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan?/contact",
    component: _7e6b634e,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/results",
    component: _bfc38080,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-results___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan?/details",
    component: _4003e297,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/:plan?/details",
    component: _b0573926,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan?/obrigado",
    component: _64592bde,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan?/contact",
    component: _7e6b634e,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/results",
    component: _bfc38080,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-results___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan?/details",
    component: _4003e297,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/:plan?/details",
    component: _b0573926,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan-details___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan",
    component: _b33ce9f8,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan",
    component: _b33ce9f8,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan/details",
    component: _837d99ca,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan/details",
    component: _837d99ca,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan-details___pt"
  }, {
    path: "/en/detalhes-companhia/:companyName?/:companyId?/:type",
    component: _3a343521,
    name: "detalhes-companhia-companyName-companyId-type___en"
  }, {
    path: "/pt/detalhes-companhia/:companyName?/:companyId?/:type",
    component: _3a343521,
    name: "detalhes-companhia-companyName-companyId-type___pt"
  }, {
    path: "/en/detalhes-companhia/:companyName?/:companyId?/:type?/detalhes-companhia",
    component: _73feb5ff,
    name: "detalhes-companhia-companyName-companyId-type-detalhes-companhia___en"
  }, {
    path: "/pt/detalhes-companhia/:companyName?/:companyId?/:type?/detalhes-companhia",
    component: _73feb5ff,
    name: "detalhes-companhia-companyName-companyId-type-detalhes-companhia___pt"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
